import { z } from 'zod';

/**
 * ISO 8601 timestamp in UTC, ending in `Z` (standards §1). zod 4's `z.iso.datetime()` rejects
 * local times and offsets by default, so the client never has to guess a timezone.
 */
export const IsoDateTimeSchema = z.iso.datetime().describe('ISO 8601 UTC timestamp ending in Z');
/** UTC timestamp string. */
export type IsoDateTime = z.infer<typeof IsoDateTimeSchema>;
